import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  setConfigPageSize,
  setConfigPage,
  setConfigSorted,
  setConfigFilter
} from "redux/actions/routesStatus/routesStatusAction";

export const useTableRoutesConfig = (key = '') => {
  const dispatch = useDispatch();

  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilter(key, e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSorted(key, e));
  }, []);

  const handlePage = useCallback((e) => {
    dispatch(setConfigPage(key, e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageSize(key, e));
  }, []);

  return {
    handleFilter, handleSort, handlePage, handlePageSize
  };
};
